"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChangeAddress = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _slice = require("@lce/slice");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ChangeAddress = (0, _styledComponents["default"])(_slice.Anchor).attrs({
  fontSize: 3
})(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  color: ", ";\n  text-decoration: underline;\n  line-height: 1;\n  text-transform: lowercase;\n"], ["\n  color: ", ";\n  text-decoration: underline;\n  line-height: 1;\n  text-transform: lowercase;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.black;
});
exports.ChangeAddress = ChangeAddress;
var templateObject_1;